import { Pressable, View } from 'react-native';

import NotificationMarkReadIcon from '@/assets/icons/ic-notification-mark-read.svg';
import NotificationPreferencesToggleIcon from '@/assets/icons/ic-notification-preferences-toggle.svg';
import NotificationPreferencesToggleArrowIcon from '@/assets/icons/ic-notification-preferences-toggle-arrow.svg';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type NotificationSettingsMenuProps = {
  onMarkAllRead: () => void;
  onPreferences: () => void;
};

const strings = STRINGS.guardian.notifications;

export function NotificationSettingsMenu({
  onMarkAllRead,
  onPreferences,
}: NotificationSettingsMenuProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <View style={styles.container}>
      <Pressable
        onPress={onMarkAllRead}
        style={({ pressed }) => [styles.row, pressed && styles.pressed]}>
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.text}>
          {strings.settings.markAllAsRead}
        </Text>
        <NotificationMarkReadIcon width={scale(20)} height={scale(20)} />
      </Pressable>
      <View style={styles.divider} />
      <Pressable
        onPress={onPreferences}
        style={({ pressed }) => [styles.row, pressed && styles.pressed]}>
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.text}>
          {strings.settings.notificationPreferences}
        </Text>
        <View style={styles.preferencesIcon}>
          <NotificationPreferencesToggleIcon
            width={scale(20)}
            height={scale(13.333)}
            style={styles.preferencesToggle}
          />
          <NotificationPreferencesToggleArrowIcon
            width={scale(6.667)}
            height={scale(6.667)}
            style={styles.preferencesToggleArrow}
          />
        </View>
      </Pressable>
    </View>
  );
}

const useStyles = createStyles(({ scale }) => ({
  container: {
    position: 'absolute',
    top: scale(40),
    right: 0,
    width: scale(233),
    borderRadius: scale(12),
    overflow: 'hidden',
    backgroundColor: colors['0'],
    borderWidth: 1,
    borderColor: guardianColors['2'],
    shadowColor: guardianColors['5'],
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.3,
    shadowRadius: scale(3),
    elevation: 8,
    zIndex: 20,
  },
  row: {
    height: scale(48),
    paddingHorizontal: scale(12),
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(12),
  },
  text: { color: colors['10'], flex: 1 },
  preferencesIcon: {
    position: 'relative',
    width: scale(20),
    height: scale(20),
  },
  preferencesToggle: {
    position: 'absolute',
    top: scale(3.333),
    left: 0,
  },
  preferencesToggleArrow: {
    position: 'absolute',
    top: scale(6.667),
    left: scale(10),
  },
  divider: { height: 1, backgroundColor: guardianColors['2'] },
  pressed: { opacity: 0.72 },
}));
